import { render } from "./TotalOrder.vue?vue&type=template&id=a6015aa0&ts=true"
import script from "./TotalOrder.vue?vue&type=script&lang=ts"
export * from "./TotalOrder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__